import {
  WSButton,
  WSButtons,
  WSText,
  toWSDateString
} from "@wingspanhq/fe-component-library";
import {
  Currency,
  InvoiceRow,
  InvoiceStatus
} from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { queriesInvoiceRows, queriesInvoices } from "@query";

type Props = {
  invoice: InvoiceRow;
  onClose: () => void;
};

const INVOICE_LIST_DEPENDENCIES = [
  queriesInvoiceRows.searchInvoiceRows.queryKeyBase
];

export const ModalDelete: React.FC<Props> = ({ invoice, onClose }) => {
  const [deleteInvoice, deleteInvoiceMeta] =
    queriesInvoices.deleteInvoice.useMutation({
      dependencies: INVOICE_LIST_DEPENDENCIES
    });
  const [cancelInvoice, cancelInvoiceMeta] =
    queriesInvoices.voidInvoice.useMutation({
      dependencies: INVOICE_LIST_DEPENDENCIES
    });

  const isCancel = invoice
    ? [InvoiceStatus.OPENED, InvoiceStatus.OVERDUE].includes(
        invoice.status as InvoiceStatus
      )
    : false;

  const toText = "";

  const dueDate = invoice.dueDate ?? new Date();
  const amount = invoice.amount ?? 0;

  return (
    <>
      <WSText.Heading5 mb="M">
        {isCancel ? "Cancel" : "Delete"} invoice
        {toText}
      </WSText.Heading5>
      <WSText mb="M">
        Are you sure you want to {isCancel ? "cancel" : "delete"} your{" "}
        {toWSDateString(dueDate, "monthDayYear")} invoice {toText} for{" "}
        {formatMoney(amount, invoice.currency ?? Currency.USD)}?
      </WSText>
      <WSText mb="XL">
        This action can't be undone, once you {isCancel ? "cancel" : "delete"}{" "}
        an invoice you'll have to recreate it.
      </WSText>

      <WSButtons format="modal">
        <WSButton
          destructive
          name="delete"
          onClick={() => {
            if (!invoice.id) {
              return;
            }
            if (isCancel) {
              cancelInvoice({ invoiceId: invoice.id }, { onSuccess: onClose });
            } else {
              deleteInvoice({ invoiceId: invoice.id }, { onSuccess: onClose });
            }
          }}
          loading={cancelInvoiceMeta.isLoading || deleteInvoiceMeta.isLoading}
        >
          {isCancel ? "Cancel" : "Delete"} invoice
        </WSButton>
        <WSButton.Secondary onClick={onClose}>Keep invoice</WSButton.Secondary>
      </WSButtons>
    </>
  );
};
